/* ECharts expects the JSON payload's keys verbatim (they carry the
 * actual variable names), so this wrapper deliberately bypasses
 * SFetch.json, which auto-camelizes every key.
 */

import SFetch from '@app/utils/sfetch'

const graphFetch = <T = unknown>(
  url: string,
  options: RequestInit = {}
): Promise<T> => {
  options.headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...options.headers,
  }

  return SFetch.raw(url, options).then((response) => response.json())
}

export default graphFetch
